(() => {
  const root = document.querySelector('[data-rc-parts-route]');
  if (!root || root.dataset.designMode === 'true') return;
  const target = new URL(root.dataset.rcPartsRoute, window.location.origin);
  if (target.origin !== window.location.origin || !target.pathname.includes('/collections/')) return;
  const source = new URL(window.location.href);
  if (source.pathname === target.pathname) return;
  for (const [key, value] of source.searchParams) target.searchParams.append(key, value);
  target.hash = source.hash;
  window.location.replace(target.href);
})();
